import { createContext } from 'react';
import { ISupervisionHistoryContext } from '../interfaces/supervision-history.interface';

export const SupervisionHistoryContext = createContext({} as ISupervisionHistoryContext);
